'use client';

import { Box, SxProps, Theme } from '@mui/material';

import { SearchResultItemSkeleton } from './SearchResultItemSkeleton';

export const SearchDropdownLoadingSkeleton = ({
  containerStyles = { p: 1.5 },
}: {
  containerStyles?: SxProps<Theme>;
}) => {
  const skeletonItems = Array.from({ length: 5 });

  return (
    <Box sx={containerStyles}>
      {skeletonItems.map((_, index) => (
        <SearchResultItemSkeleton key={index} />
      ))}
    </Box>
  );
};
